import { useEffect } from 'react';

const useLazyload = (ref: React.RefObject<any>, onLoad: () => void): void => {
  useEffect(() => {
    if (!ref.current) {
      return;
    }

    const intersectionObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          onLoad();
          observer.disconnect();
        }
      });
    });

    intersectionObserver.observe(ref.current);
  }, [ref, onLoad]);
};

export default useLazyload;
